module.exports = __webpack_public_path__ + "img/auto-sliding-carousel-fullscreen.2de44cfa.png";